import { useMenu } from "../../../contexts/menu/menu.hook";
import { MenuContentOptions } from "../../../contexts/menu/Menu.types";
import styles from "../Menu.module.scss";

export const MenuContentTrailer = ({
  trailerLink,
}: {
  trailerLink: string;
}) => {
  const { setMenuContent } = useMenu();

  if (!trailerLink) {
    setMenuContent(MenuContentOptions.NAVIGATION);
  }

  return (
    <div className={styles.trailerWrapper}>
      <iframe
        src={trailerLink}
        title="Skillhouse trailer"
        className={styles.trailerIframe}
      />
    </div>
  );
};
